import { CollapsableRow, TableWithPagination } from '@clickcease/cc-client-components-lib'
import React, { useState, useEffect } from 'react'
import { NewActiveDomainRow } from './NewActiveDomainRow'
import { NewDomainExpendedDrilldown } from './Components/NewDomainExpandedDrilldown'
import { useActiveDomainsWithTrends } from 'Features/home/hooks/useActiveDomainsWithTrends'
import { EmptyTable } from './Components/EmptyTable'
import { TableRowsWrapper } from './OverallDomainPreformance.styled'
import { usePagination } from 'Hooks/usePagination'
import { paginationLimit } from 'Features/home/components/OverallDomainsPreformance/utils'

const MAX_EXPANDED_ROWS = 3

type NewDomainTableDataProps = {
  debouncedSearch: string
}

export const NewDomainsTableData = ({ debouncedSearch }: NewDomainTableDataProps) => {
  const [currentPageState, setCurrentPageState] = useState<number>(1)
  const { activeDomainsArrayWithAddedData, isDomainsDataLoading } = useActiveDomainsWithTrends(
    currentPageState,
    paginationLimit,
    debouncedSearch
  )

  const pageCount = activeDomainsArrayWithAddedData?.data?.metadata?.pageCount
    ? activeDomainsArrayWithAddedData.data.metadata.pageCount
    : 0

  const totalCount = activeDomainsArrayWithAddedData?.data?.metadata?.totalCount
    ? activeDomainsArrayWithAddedData.data.metadata.totalCount
    : 0

  const {
    currentPage,
    onFirstPage: handleFirstPage,
    onLastPage: handleLastPage,
    onNextPage: handleNextPage,
    onPreviousPage: handlePrevPage,
  } = usePagination({
    pageCount: pageCount || 0,
  })

  useEffect(() => {
    setCurrentPageState(currentPage)
  }, [currentPage])

  const body =
    !isDomainsDataLoading && activeDomainsArrayWithAddedData ? (
      activeDomainsArrayWithAddedData?.data?.domains?.map((domain, index) => (
        <CollapsableRow
          key={domain.address}
          openByDefault={index < MAX_EXPANDED_ROWS}
          visibleContent={
            <NewActiveDomainRow
              address={domain.address}
              paidMarketingTrend={domain.paidMarketingInvalidTrend}
              botMitigationTrend={domain.botMitigationInvalidTrend}
              hasBotZapping={domain.botZapping && domain.botZappingConnected}
              hasPaidMarketing={domain.paidMarketing && domain.paidMarketingConnected}
              isBmLoading={isDomainsDataLoading}
            />
          }
          collapsableContent={
            <NewDomainExpendedDrilldown
              domain={domain.address}
              botMitigationData={domain.bmSummary}
              hasBotZapping={domain.botZapping && domain.botZappingConnected}
              hasPaidMarketing={domain.paidMarketing && domain.paidMarketingConnected}
              isBmLoading={isDomainsDataLoading}
            />
          }
          triggerCellFlex={0.1}
        />
      ))
    ) : (
      <EmptyTable isActiveTable={true} isLoading={isDomainsDataLoading} />
    )

  return (
    <TableRowsWrapper>
      <TableWithPagination
        body={body}
        pageCount={Math.ceil(pageCount)}
        currentPage={currentPage}
        totalItems={totalCount}
        limitPerPage={paginationLimit}
        textOfSelection={''}
        onFirstPage={handleFirstPage}
        onLastPage={handleLastPage}
        onNextPage={handleNextPage}
        onPreviousPage={handlePrevPage}
        wrapperStyle={{ height: '600px' }}
        tableStyle={{ width: '100%' }}
      />
    </TableRowsWrapper>
  )
}
